export default __webpack_public_path__ + "static/media/login-bg.5fb8688e.jpg";